<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 182 141"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>gamers</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-53.000000, -443.000000)">
        <g
          id="gamers"
          transform="translate(54.000000, 443.000000)">
          <g id="Background">
            <g id="New_Symbol_77">
              <path
                id="Path"
                d="M172.758677,82.7931034 C172.755455,48.9957461 152.201414,18.5962221 120.838102,6.0024119 C89.4747908,-6.59139825 53.6048871,1.15132035 30.2289633,25.5608995 C6.85303946,49.9704787 0.668651949,86.1416417 14.6068966,116.931034 L165.372414,116.931034 C170.253425,106.212851 172.772439,94.5703504 172.758677,82.7931034 L172.758677,82.7931034 Z"
                fill="#EBF3FF"
                fill-rule="nonzero" />
              <line
                id="Path"
                x1="9.31034483"
                y1="116.931034"
                x2="170.689655"
                y2="116.931034"
                class="stroke"
                stroke-width="2.06896552"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="0"
                y1="116.931034"
                x2="5.17241379"
                y2="116.931034"
                class="stroke"
                stroke-width="2.06896552"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="174.827586"
                y1="116.931034"
                x2="180"
                y2="116.931034"
                class="stroke"
                stroke-width="2.06896552"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </g>
          <g
            id="Scene"
            transform="translate(16.551724, 7.275862)">
            <path
              id="Path"
              d="M128.275862,94.137931 C128.275862,76.4267304 113.918097,62.0689655 96.2068966,62.0689655 C78.495696,62.0689655 64.137931,76.4267304 64.137931,94.137931 L64.137931,97.2413793 C64.137931,98.3840374 65.0642384,99.3103448 66.2068966,99.3103448 L76.5517241,99.3103448 L76.5517241,109.655172 L115.862069,109.655172 L115.862069,99.3103448 L126.206897,99.3103448 C127.349555,99.3103448 128.275862,98.3840374 128.275862,97.2413793 L128.275862,94.137931 Z"
              class="fill-light"
              fill-rule="nonzero" />
            <ellipse
              id="Oval"
              fill="#EBF3FF"
              fill-rule="nonzero"
              cx="57.9310345"
              cy="127.241379"
              rx="42.4137931"
              ry="3.10344828" />
            <path
              id="Path"
              d="M128.275862,94.137931 C128.275862,76.4267304 113.918097,62.0689655 96.2068966,62.0689655 C78.495696,62.0689655 64.137931,76.4267304 64.137931,94.137931 L64.137931,97.2413793 C64.137931,98.3840374 65.0642384,99.3103448 66.2068966,99.3103448 L76.5517241,99.3103448 L76.5517241,109.655172 L115.862069,109.655172 L115.862069,99.3103448 L126.206897,99.3103448 C127.349555,99.3103448 128.275862,98.3840374 128.275862,97.2413793 L128.275862,94.137931 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="76.5517241"
              y1="91.0344828"
              x2="76.5517241"
              y2="109.655172"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="115.862069"
              y1="91.0344828"
              x2="115.862069"
              y2="109.655172"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M43.4482759,121.034483 C43.4596157,118.182548 45.7687547,115.873409 48.6206897,115.862069 L50.6896552,115.862069 C59.2595909,115.862069 66.2068966,108.914763 66.2068966,100.344828 L66.2068966,99.3103448 L76.5517241,99.3103448 L76.5517241,100.344828 C76.540304,114.6314 64.9555425,126.206897 50.6689655,126.206897 L48.6,126.206897 C45.7561481,126.184258 43.4595162,123.878403 43.4482759,121.034483 Z"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M93.1034483,121.034483 C93.1034483,118.177838 95.4192168,115.862069 98.2758621,115.862069 L100.344828,115.862069 C108.910038,115.850671 115.850671,108.910038 115.862069,100.344828 L115.862069,99.3103448 L126.206897,99.3103448 L126.206897,100.344828 C126.184113,114.618606 114.618606,126.184113 100.344828,126.206897 L98.2758621,126.206897 C95.4192168,126.206897 93.1034483,123.891128 93.1034483,121.034483 Z"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M88.9655172,63.1034483 C88.9655172,67.1027516 92.2075932,70.3448276 96.2068966,70.3448276 C100.2062,70.3448276 103.448276,67.1027516 103.448276,63.1034483 L103.448276,55.862069 L88.9655172,55.862069 L88.9655172,63.1034483 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M88.9655172,63.1034483 L88.9655172,55.862069 L103.448276,55.862069 L103.448276,63.1034483 C103.448276,67.1027516 100.2062,70.3448276 96.2068966,70.3448276 C92.2075932,70.3448276 88.9655172,67.1027516 88.9655172,63.1034483 L88.9655172,63.1034483 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M95.4413793,121.737931 C95.2774585,120.726087 94.3973644,119.986808 93.3724138,120 L22.4275862,120 C21.4026356,119.986808 20.5225415,120.726087 20.3586207,121.737931 L20.0068966,123.806897 C19.9054942,124.405238 20.0719041,125.017929 20.462069,125.482759 C20.859859,125.947889 21.4431712,126.213031 22.0551724,126.206897 L93.7655172,126.206897 C94.3703003,126.206936 94.944822,125.942354 95.337931,125.482759 C95.7280959,125.017929 95.8945058,124.405238 95.7931034,123.806897 L95.4413793,121.737931 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M28.9655172,116.896552 L24.8275862,116.896552 C24.2562572,116.896552 23.7931034,117.359705 23.7931034,117.931034 L23.7931034,120 L30,120 L30,117.931034 C30,117.359705 29.5368463,116.896552 28.9655172,116.896552 Z"
              class="stroke"
              stroke-width="2.06896552"
              fill="#CCE1FF"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M39.3103448,116.896552 L35.1724138,116.896552 C34.6010847,116.896552 34.137931,117.359705 34.137931,117.931034 L34.137931,120 L40.3448276,120 L40.3448276,117.931034 C40.3448276,117.359705 39.8816739,116.896552 39.3103448,116.896552 Z"
              class="stroke"
              stroke-width="2.06896552"
              fill="#CCE1FF"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M49.6551724,116.896552 L45.5172414,116.896552 C44.9459123,116.896552 44.4827586,117.359705 44.4827586,117.931034 L44.4827586,120 L50.6896552,120 L50.6896552,117.931034 C50.6896552,117.359705 50.2265015,116.896552 49.6551724,116.896552 Z"
              class="stroke"
              stroke-width="2.06896552"
              fill="#CCE1FF"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M60,116.896552 L55.862069,116.896552 C55.2907399,116.896552 54.8275862,117.359705 54.8275862,117.931034 L54.8275862,120 L61.0344828,120 L61.0344828,117.931034 C61.0344828,117.359705 60.5713291,116.896552 60,116.896552 Z"
              class="stroke"
              stroke-width="2.06896552"
              fill="#CCE1FF"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M70.3448276,116.896552 L66.2068966,116.896552 C65.6355675,116.896552 65.1724138,117.359705 65.1724138,117.931034 L65.1724138,120 L71.3793103,120 L71.3793103,117.931034 C71.3793103,117.359705 70.9161566,116.896552 70.3448276,116.896552 Z"
              class="stroke"
              stroke-width="2.06896552"
              fill="#CCE1FF"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M80.6896552,116.896552 L76.5517241,116.896552 C75.9803951,116.896552 75.5172414,117.359705 75.5172414,117.931034 L75.5172414,120 L81.7241379,120 L81.7241379,117.931034 C81.7241379,117.359705 81.2609842,116.896552 80.6896552,116.896552 Z"
              class="stroke"
              stroke-width="2.06896552"
              fill="#CCE1FF"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M91.0344828,116.896552 L86.8965517,116.896552 C86.3252227,116.896552 85.862069,117.359705 85.862069,117.931034 L85.862069,120 L92.0689655,120 L92.0689655,117.931034 C92.0689655,117.359705 91.6058118,116.896552 91.0344828,116.896552 Z"
              class="stroke"
              stroke-width="2.06896552"
              fill="#CCE1FF"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M111.103448,126.206897 C110.407946,126.21487 109.754979,125.872839 109.365517,125.296552 C108.981999,124.72025 108.912113,123.990329 109.17931,123.351724 C110.830782,120.035797 114.21627,117.939782 117.92069,117.939782 C121.62511,117.939782 125.010598,120.035797 126.662069,123.351724 C126.929266,123.990329 126.85938,124.72025 126.475862,125.296552 C126.090475,125.866715 125.446813,126.207933 124.758621,126.206897 L111.103448,126.206897 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M117.931034,124.137931 C117.931034,128.708563 114.225805,132.413793 109.655172,132.413793 L15.5172414,132.413793"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M57.9310345,124.137931 C57.9310345,128.708563 54.2258048,132.413793 49.6551724,132.413793"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M38.2758621,66.2068966 L53.4827586,73.3655172 C54.9346033,74.0471771 55.8617588,75.5064392 55.862069,77.1103448 L55.862069,109.655172 L38.2758621,109.655172 L38.2758621,66.2068966 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M45.7862069,66.2068966 L2.06896552,66.2068966 C0.926307414,66.2068966 0,67.133204 0,68.2758621 L0,109.655172 L53.7931034,109.655172 L47.8344828,67.9862069 C47.6901945,66.9657265 46.8168375,66.2068966 45.7862069,66.2068966 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="fill-white"
              fill-rule="nonzero"
              x="4.13793103"
              y="70.3448276"
              width="28.9655172"
              height="28.9655172"
              rx="2.06896552" />
            <path
              id="Path"
              d="M14.2344828,95.1724138 L4.13793103,95.1724138 L4.13793103,86.8965517 L16.3034483,86.8965517 C17.0205377,86.8987218 17.6853695,87.2720528 18.0604902,87.8832045 C18.4356109,88.4943562 18.4675226,89.2561691 18.1448276,89.8965517 L16.0758621,94.0344828 C15.7252754,94.7302338 15.0135687,95.1700525 14.2344828,95.1724138 Z"
              class="fill-extra-light"
              fill-rule="nonzero" />
            <rect
              id="Rectangle"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="19.6551724"
              y="73.4482759"
              width="10.3448276"
              height="18.6206897"
              rx="2.06896552" />
            <circle
              id="Oval"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              cx="24.8275862"
              cy="78.6206897"
              r="3.10344828" />
            <circle
              id="Oval"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              cx="24.8275862"
              cy="86.8965517"
              r="3.10344828" />
            <path
              id="Path"
              d="M13.2,93.1034483 L4.13793103,93.1034483 L4.13793103,88.9655172 L14.8758621,88.9655172 C15.2344233,88.9601285 15.5691548,89.1445651 15.7561476,89.4505535 C15.9431405,89.7565418 15.9545706,90.1385514 15.7862069,90.4551724 L15.0413793,91.9655172 C14.6907926,92.6612682 13.979086,93.101087 13.2,93.1034483 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="4.13793103"
              y="70.3448276"
              width="28.9655172"
              height="28.9655172"
              rx="2.06896552" />
            <path
              id="Path"
              d="M4.13793103,78.6206897 C4.13793103,78.6206897 5.13103448,85.3448276 10.862069,85.3448276 C14.1657128,85.3954124 17.3450087,84.0862906 19.6551724,81.7241379"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M4.13793103,75.5172414 C4.13793103,75.5172414 5.02758621,81.7241379 10.3448276,81.7241379 C13.6884307,81.641892 16.9309423,80.5610548 19.6551724,78.6206897"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="37.2413793"
              y1="77.5862069"
              x2="43.4482759"
              y2="77.5862069"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="37.2413793"
              y1="84.8275862"
              x2="44.4827586"
              y2="84.8275862"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="37.2413793"
              y1="92.0689655"
              x2="45.5172414"
              y2="92.0689655"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="37.2413793"
              y1="99.3103448"
              x2="46.5517241"
              y2="99.3103448"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M116.896552,34.137931 L116.896552,28.9655172 C116.896552,17.5389362 107.633478,8.27586207 96.2068966,8.27586207 C84.7803155,8.27586207 75.5172414,17.5389362 75.5172414,28.9655172 L75.5172414,34.137931 C73.2319252,34.137931 71.3793103,35.9905459 71.3793103,38.2758621 C71.3793103,40.5611783 73.2319252,42.4137931 75.5172414,42.4137931 L75.7655172,42.4137931 C77.3681388,52.4543894 86.0288593,59.8423655 96.1965517,59.8423655 C106.364244,59.8423655 115.024965,52.4543894 116.627586,42.4137931 L116.896552,42.4137931 C119.181868,42.4137931 121.034483,40.5611783 121.034483,38.2758621 C121.034483,35.9905459 119.181868,34.137931 116.896552,34.137931 Z"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M82.7586207,23.5241379 C82.7586207,23.5241379 93.7448276,23.7724138 97.2413793,21.1241379 L96.3724138,24.9724138 C96.3724138,24.9724138 105.206897,23.0275862 107.751724,18.3517241 L107.751724,22.4896552 C107.751724,22.4896552 110.151724,21.2068966 110.648276,19.4482759 C113.657135,23.7236995 115.169942,28.8730602 114.951724,34.0965517 L117.02069,34.0965517 C119.516448,29.3951337 120.116169,23.9161999 118.696552,18.7862069 C116.358621,10.0551724 110.875862,11.4827586 110.875862,11.4827586 C110.875862,11.4827586 114.351724,2.17241379 94.1793103,3.64137931 C71.4206897,5.27586207 69.7448276,24.8482759 75.5586207,34.0965517 L77.2758621,34.0965517 C77.2758621,34.0965517 77.0689655,23.7103448 82.7586207,23.5241379 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M82.7586207,23.5241379 C82.7586207,23.5241379 93.7448276,23.7724138 97.2413793,21.1241379 L96.3724138,24.9724138 C96.3724138,24.9724138 105.206897,23.0275862 107.751724,18.3517241 L107.751724,22.4896552 C107.751724,22.4896552 110.151724,21.2068966 110.648276,19.4482759 C113.657135,23.7236995 115.169942,28.8730602 114.951724,34.0965517 L117.02069,34.0965517 C119.516448,29.3951337 120.116169,23.9161999 118.696552,18.7862069 C116.358621,10.0551724 110.875862,11.4827586 110.875862,11.4827586 C110.875862,11.4827586 114.351724,2.17241379 94.1793103,3.64137931 C71.4206897,5.27586207 69.7448276,24.8482759 75.5586207,34.0965517 L77.2758621,34.0965517 C77.2758621,34.0965517 77.0689655,23.7103448 82.7586207,23.5241379 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M89.9586207,48.2068966 C93.4468938,51.4860671 98.8841407,51.4860671 102.372414,48.2068966"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M107.586207,36.2068966 C107.056919,34.9622692 105.835254,34.1542492 104.482759,34.1542492 C103.130264,34.1542492 101.908598,34.9622692 101.37931,36.2068966"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M91.0344828,36.2068966 C90.5051949,34.9622692 89.2835296,34.1542492 87.9310345,34.1542492 C86.5785394,34.1542492 85.3568741,34.9622692 84.8275862,36.2068966"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="84.3103448"
              cy="42.9310345"
              r="2.5862069" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="108.103448"
              cy="42.9310345"
              r="2.5862069" />
            <path
              id="Path"
              d="M74.4827586,47.5862069 L71.3793103,47.5862069 C70.8079813,47.5862069 70.3448276,47.1230532 70.3448276,46.5517241 L70.3448276,32.0689655 C70.3448276,31.4976365 70.8079813,31.0344828 71.3793103,31.0344828 L74.4827586,31.0344828 C75.6254167,31.0344828 76.5517241,31.9607902 76.5517241,33.1034483 L76.5517241,45.5172414 C76.5517241,46.6598995 75.6254167,47.5862069 74.4827586,47.5862069 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M66.2068966,45.5172414 L70.3448276,45.5172414 L70.3448276,33.1034483 L66.2068966,33.1034483 C65.0642384,33.1034483 64.137931,34.0297557 64.137931,35.1724138 L64.137931,43.4482759 C64.137931,44.590934 65.0642384,45.5172414 66.2068966,45.5172414 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M117.931034,47.5862069 L121.034483,47.5862069 C121.605812,47.5862069 122.068966,47.1230532 122.068966,46.5517241 L122.068966,32.0689655 C122.068966,31.4976365 121.605812,31.0344828 121.034483,31.0344828 L117.931034,31.0344828 C116.788376,31.0344828 115.862069,31.9607902 115.862069,33.1034483 L115.862069,45.5172414 C115.862069,46.6598995 116.788376,47.5862069 117.931034,47.5862069 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M128.275862,43.4482759 C128.275862,44.590934 127.349555,45.5172414 126.206897,45.5172414 L122.068966,45.5172414 L122.068966,33.1034483 L126.206897,33.1034483 C127.349555,33.1034483 128.275862,34.0297557 128.275862,35.1724138 L128.275862,43.4482759 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M124.137931,33.1034483 C124.137931,17.6775639 111.632781,5.17241379 96.2068966,5.17241379 C80.7810122,5.17241379 68.2758621,17.6775639 68.2758621,33.1034483 L68.2758621,27.9310345 C68.2758621,12.5051501 80.7810122,0 96.2068966,0 C111.632781,0 124.137931,12.5051501 124.137931,27.9310345 L124.137931,33.1034483 Z"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M86.8965517,60 L82.7586207,60 C81.6159626,60 80.6896552,59.0736926 80.6896552,57.9310345 L80.6896552,57.9310345 C80.6896552,56.7883764 81.6159626,55.862069 82.7586207,55.862069 L86.8965517,55.862069 C88.0392098,55.862069 88.9655172,56.7883764 88.9655172,57.9310345 L88.9655172,57.9310345 C88.9655172,59.0736926 88.0392098,60 86.8965517,60 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M80.6896552,57.9310345 L76.5517241,57.9310345 C71.9810917,57.9310345 68.2758621,54.2258048 68.2758621,49.6551724 L68.2758621,45.5172414"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
